<app-breadcrumb [title]="'Asistentes'" [items]="['Capacitaciones','Programación']" [active_item]="'Asistentes'">
</app-breadcrumb>

<div class="container-fluid">
    <div class="card shadow-sm border-0">
        <div class="card-header d-flex align-items-center justify-content-between bg-primary text-white">
            <div class="d-flex align-items-center">
                <i class="icofont icofont-business-man-alt-2 me-2"></i>
                <h5 class="mb-0">
                    <strong>
                        ASISTENTES
                        <span *ngIf="selectedProgramacionCapacitacionNombre"> – {{
                            selectedProgramacionCapacitacionNombre }}</span>
                    </strong>
                </h5>
            </div>
            <button class="btn btn-light btn-sm" type="button" (click)="volver()">
                <i class="fa fa-arrow-left me-1"></i> Volver
            </button>
        </div>

        <div class="card-body custom-datatable">
            <!-- TABS -->
            <ul class="nav nav-tabs mb-3" role="tablist">
                <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)" [class.active]="modalAsistentesTab === 'invitados'"
                        (click)="modalAsistentesTab = 'invitados'">
                        <i class="icofont icofont-ui-user-group me-1"></i>Invitados
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)" [class.active]="modalAsistentesTab === 'asistentes'"
                        (click)="modalAsistentesTab = 'asistentes'">
                        <i class="icofont icofont-business-man-alt-2 me-1"></i>Asistentes
                    </a>
                </li>
            </ul>

            <!-- ===================== TAB INVITADOS ===================== -->
            <div *ngIf="modalAsistentesTab === 'invitados'">
                <div class="custom-datatable table-responsive">
                    <table class="table table-hover table-bordered" id="tblInvitados">
                        <thead class="bg-primary">
                            <tr>
                                <th class="text-center"><strong>N° DOCUMENTO</strong></th>
                                <th class="text-center"><strong>NOMBRE</strong></th>
                                <th class="text-center"><strong>ACTIVIDAD</strong></th>
                                <th class="text-center"><strong>HORA INGRESO</strong></th>
                                <th class="text-center"><strong>ASISTIÓ</strong></th>
                                <th class="text-center"><strong>ACCIONES</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let invitado of invitadosProgramacion">
                                <td class="text-center">{{ invitado.propietario_id || "-" }}</td>
                                <td class="text-center text-uppercase">{{ invitado.nombre || "-" }}</td>
                                <td class="text-center text-uppercase">{{ invitado.InvitadosData?.actividad || "-" }}
                                </td>
                                <td class="text-center text-uppercase">{{ invitado.fechaCreacion | date:'hh:mm a -
                                    dd/MM/yyyy':'':'en-US' }}</td>
                                <td class="text-center">
                                    <span class="badge" [ngClass]="invitado.asistio == 1 ? 'bg-success' : 'bg-danger'">
                                        {{ invitado.asistio == 1 ? "Sí" : "No" }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <div class="action">
                                        <ul class="list-inline m-0">
                                            <li class="delete list-inline-item" (click)="quitarInvitado(invitado)">
                                                <a href="javascript:void(0)"><i class="icon-trash"
                                                        ngbTooltip="Quitar invitado"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!loadingInvitados && invitadosProgramacion.length === 0">
                                <td colspan="4" class="text-center text-primary py-4">
                                    No hay invitados registrados para esta capacitación.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="text-center flex-grow-1 mb-2">
                    Total Registros: <a class="badge badge-primary"><b>{{ invitadosProgramacion?.length }}</b></a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <button class="btn btn-outline-primary btn-sm" type="button"
                        (click)="abrirModalAgregarInvitados(agregarInvitadosModal)">
                        <i class="fa fa-plus"></i> Agregar invitado
                    </button>
                </div>
            </div>

            <!-- ===================== TAB ASISTENTES ===================== -->
            <div *ngIf="modalAsistentesTab === 'asistentes'">
                <div class="custom-datatable table-responsive mt-2">
                    <table class="table table-hover table-bordered" id="tblAsistencias">
                        <thead class="bg-primary">
                            <tr>
                                <th class="text-center"><strong>N° DOCUMENTO</strong></th>
                                <th class="text-center"><strong>NOMBRE</strong></th>
                                <th class="text-center"><strong>ACTIVIDAD / TEMA</strong></th>
                                <th class="text-center"><strong>HORA INGRESO</strong></th>
                                <th class="text-center"><strong>ASISTIÓ</strong></th>
                                <th class="text-center"><strong>APROBADO</strong></th>
                                <th class="text-center"><strong>CALIFICACIÓN</strong></th>
                                <th class="text-center"><strong>ACCIONES</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let asistentes of filteredTableItemsAsistencia | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                <td class="text-center">{{ asistentes.cedula || "-" }}</td>
                                <td class="text-uppercase">{{ asistentes.nombre || "-" }}</td>
                                <td class="text-uppercase">{{ obtenerNombreActividad(asistentes.actividad_id) }}</td>
                                <td class="text-center text-uppercase">{{ asistentes.fechaCreacion | date:'hh:mm a -
                                    dd/MM/yyyy':'':'en-US' }}</td>
                                <td class="text-center">
                                    <span class="badge"
                                        [ngClass]="asistioLabel(asistentes) ? 'bg-success' : 'bg-danger'">
                                        {{ asistioLabel(asistentes) ? "Sí" : "No" }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <span class="badge"
                                        [ngClass]="aprobadoLabel(asistentes) ? 'bg-success' : 'bg-danger'">
                                        {{ aprobadoLabel(asistentes) ? "Sí" : "No" }}
                                    </span>
                                </td>
                                <td class="text-center">{{ asistentes.calificacion ?? "-" }}</td>
                                <td class="text-center">
                                    <div class="action">
                                        <ul class="list-inline m-0">
                                            <li class="edit list-inline-item"
                                                (click)="abrirModalAsistente(asistentes, asistenciaModal)">
                                                <a href="javascript:void(0)"><i class="icon-pencil-alt"
                                                        ngbTooltip="Editar"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!loading && filteredTableItemsAsistencia.length === 0">
                                <td colspan="8" class="text-center text-primary py-4">
                                    No hay asistentes registrados para esta capacitación.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-4">
                    <div class="d-flex align-items-center">
                        <label for="pageSize" class="me-2">Mostrar:</label>
                        <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                    </div>

                    <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ filteredTableItemsAsistencia?.length
                                }}</b></a>
                    </div>

                    <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                    </div>
                </div>

                <div class="mt-4">
                    <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button"
                            (click)="exportarExcel('tblAsistencias', 'Listado_asistencias')">
                            <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>
                        <button class="btn btn-outline-danger-2x" type="button"
                            (click)="exportToPDF('tblAsistencias', 'Listado_asistencias', 'Listado de Asistencias a Capacitaciones')">
                            <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                        <button class="btn btn-outline-primary-2x" type="button"
                            (click)="abrirModalAsistente(null, asistenciaModal)">
                            <i class="fa fa-plus"></i> CREAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ===================== MODAL ÚNICO ASISTENCIA ===================== -->
<ng-template #asistenciaModal let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title mb-0">
            <strong>{{ modoEdicion ? "EDITAR ASISTENCIA" : "NUEVA ASISTENCIA" }}</strong>
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label text-dark"><strong>Capacitación:</strong><a class="text-danger">*</a></label>
                <ng-select [items]="capacitacionesFiltradas" bindLabel="nombre" bindValue="id"
                    [(ngModel)]="asistenciaForm.capacitacion_id" placeholder="Seleccione..."
                    [clearable]="false"></ng-select>
            </div>

            <div class="col-md-6">
                <label class="form-label text-dark"><strong>N° Documento:</strong><a class="text-danger">*</a></label>
                <input type="number" class="form-control" placeholder="Ingrese el número de documento"
                    [(ngModel)]="asistenciaForm.cedula" />
            </div>
            <div class="col-md-6">
                <label class="form-label text-dark"><strong>Nombre Completo:</strong><a
                        class="text-danger">*</a></label>
                <input type="text" placeholder="Ingrese el nombre y apellido completo"
                    class="form-control text-uppercase" [(ngModel)]="asistenciaForm.nombre" />
            </div>
            <div class="col-md-6">
                <label class="form-label text-dark"><strong>Calificación:</strong></label>
                <input type="number" placeholder="Ingrese la calificación" class="form-control"
                    [(ngModel)]="asistenciaForm.calificacion" />
            </div>
            <div class="col-md-6">
                <label class="form-label text-dark"><strong>Asistió:</strong></label>
                <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre"
                    bindValue="id" [(ngModel)]="asistenciaForm.asistio" [clearable]="false"></ng-select>
            </div>
            <div class="col-md-6">
                <label class="form-label text-dark"><strong>Aprobado:</strong></label>
                <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre"
                    bindValue="id" [(ngModel)]="asistenciaForm.aprobado" [clearable]="false"></ng-select>
            </div>
            <div class="col-md-12">
                <label class="form-label text-dark"><strong>Actividad / Tema:</strong><a
                        class="text-danger">*</a></label>
                <ng-select [items]="temasProgramacion" bindLabel="actividad" bindValue="id" groupBy="grupoLabel"
                    [(ngModel)]="asistenciaForm.actividad_id" placeholder="Seleccione la actividad a la que asistió..."
                    [clearable]="false"
                    notFoundText="Esta programación no tiene actividades/temas registrados"></ng-select>

                <!-- Detalle de la sesión (fecha, horario, dirigido, responsable) del tema elegido -->
                <div class="tema-info-card mt-2 p-2 rounded bg-primary border"
                    *ngIf="obtenerTemaSeleccionado(asistenciaForm.actividad_id) as tema">
                    <div class="row g-2 small">
                        <div class="col-6 col-md-3">
                            <i class="fa fa-calendar text-light me-1"></i>
                            <strong>Fecha:</strong> {{ formatearFechaCorta(tema.fecha_programacion) }}
                        </div>
                        <div class="col-6 col-md-3">
                            <i class="fa fa-clock-o text-light me-1"></i>
                            <strong>Horario:</strong> {{ tema.hora_inicio }} - {{ tema.hora_fin }}
                        </div>
                        <div class="col-6 col-md-3">
                            <i class="fa fa-users text-light me-1"></i>
                            <strong>Dirigido a:</strong> {{ tema.dirigido_nombre }}
                        </div>
                        <div class="col-6 col-md-3">
                            <i class="fa fa-user text-light me-1"></i>
                            <strong>Responsable:</strong> {{ tema.responsable_nombre }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <label class="form-label text-dark"><strong>Observaciones:</strong></label>
                <textarea rows="4" class="form-control" placeholder="Ingrese observaciones (opcional)"
                    [(ngModel)]="asistenciaForm.observaciones"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarAsistencia()">
            <span *ngIf="!loading">{{ modoEdicion ? "Actualizar" : "Guardar" }}</span>
            <span *ngIf="loading">Guardando...</span>
        </button>
    </div>
</ng-template>

<ng-template #agregarInvitadosModal let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title mb-0">
            <strong>AGREGAR INVITADOS <span *ngIf="selectedProgramacionCapacitacionNombre"> – {{
                    selectedProgramacionCapacitacionNombre }}</span></strong>
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <label class="form-label text-dark"><strong>Agregar invitado por cédula:</strong></label>
        <div class="input-group">
            <input class="form-control" type="number" placeholder="Ingrese el número de documento"
                [(ngModel)]="cedulaBuscada" [disabled]="buscandoInvitado" (keyup.enter)="buscarInvitadoPorCedula()" />
            <button class="btn btn-outline-primary" type="button" [disabled]="buscandoInvitado"
                (click)="buscarInvitadoPorCedula()">
                <i class="fa fa-search" *ngIf="!buscandoInvitado"></i>
                <span *ngIf="buscandoInvitado" class="spinner-border spinner-border-sm"></span>
            </button>
        </div>

        <div class="border border-warning rounded p-3 mt-3" *ngIf="personaNoEncontrada">
            <p class="text-warning mb-2">
                <i class="fa fa-exclamation-triangle me-1"></i>
                No se encontró ninguna persona con esa cédula. Puedes agregarla manualmente:
            </p>
            <div class="row g-2">
                <div class="col-md-4">
                    <input type="number" class="form-control" placeholder="Cédula"
                        [(ngModel)]="nuevoInvitadoManual.cedula" />
                </div>
                <div class="col-md-5">
                    <input type="text" class="form-control text-uppercase" placeholder="Nombre completo"
                        [(ngModel)]="nuevoInvitadoManual.nombre" />
                </div>
                <div class="col-md-3 d-flex">
                    <button class="btn btn-success me-2" type="button" (click)="agregarInvitadoManual()"><i
                            class="fa fa-plus"></i> Agregar</button>
                    <button class="btn btn-outline-secondary" type="button"
                        (click)="cancelarAgregarManual()">Cancelar</button>
                </div>
            </div>
        </div>

        <div class="mt-3" *ngIf="invitadosSeleccionados.length > 0">
            <h6 class="mb-3 text-dark">Invitados agregados:</h6>
            <table class="table table-sm table-bordered mb-0">
                <thead class="bg-primary text-white">
                    <tr>
                        <th>N° Documento</th>
                        <th>Nombre</th>
                        <th width="80" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let inv of invitadosSeleccionados">
                        <td>{{ inv.cedula }}</td>
                        <td class="text-uppercase">{{ inv.nombre }}</td>
                        <td class="text-center">
                            <button class="btn btn-sm btn-danger" type="button"
                                (click)="eliminarInvitado(inv.cedula)"><i class="fa fa-times"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarNuevosInvitados()">
            <span *ngIf="!loading">Guardar</span>
            <span *ngIf="loading">Guardando...</span>
        </button>
    </div>
</ng-template>